import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { DxDataGridComponent } from "devextreme-angular";
import { custom } from "devextreme/ui/dialog";
import { CarrierItemFlowService } from "src/app/_api/services/carrier-item-flow.service";
import { AmsNotifierService } from "src/app/shared/services/ams-notifier.service";
import { LanguageService } from "src/app/shared/services/language.service";

@Component({
  selector: "app-project-portal-approval-details-carrier-item-flows",
  templateUrl: "./carrier-item-flows.component.html",
  styleUrls: ["./carrier-item-flows.component.css"],
})
export class ProjectPortalApprovalDetailsCarrierItemFlowsComponent {
  @Input() carrierItemFlows: any[];
  @Input() items: any[];
  @Input() itemFlowTypes: any[];
  @Input() selectedTimeRecord: any;
  @Input() allowEdit: boolean;

  @Output() isBusy = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<boolean>(); //false if not clearing datagrid selections
  @Output() editingStart = new EventEmitter<any>();
  @Output() loading = new EventEmitter<boolean>(); //emit event to parent(project-portal.component) to show load indicator

  isClone: boolean = false;
  cloneData: any;

  @ViewChild("datagriddx", { static: false })
  carrierItemFlowGrid: DxDataGridComponent;

  constructor(
    public languageService: LanguageService,
    private carrierItemFlowService: CarrierItemFlowService,
    private amsNotifierService: AmsNotifierService
  ) {}

  private async loadCarrierItemFlows(): Promise<any> {
    this.carrierItemFlows = await this.carrierItemFlowService
      .getByTime(this.selectedTimeRecord.TimeId)
      .toPromise();
  }

  onToolbarPreparing(e) {
    if (this.allowEdit) {
      e.toolbarOptions.items.unshift(
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "copy",
            title: this.languageService.LNG("Label.Copy"),
            onClick: this.onCopySelected.bind(this),
          },
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "trash",
            title: this.languageService.LNG("Label.Delete"),
            onClick: this.onDeleteSelected.bind(this),
          },
        }
      );
    }
  }

  onCopySelected() {
    let selectedRowsData =
      this.carrierItemFlowGrid.instance.getSelectedRowsData();
    if (selectedRowsData.length > 0) {
      for (let i = 0; i < selectedRowsData.length; i++) {
        this.isClone = true;
        this.cloneData = selectedRowsData[i];
        this.carrierItemFlowGrid.instance.addRow();
      }
    }
  }

  onDeleteSelected() {
    let myDialog = custom({
      title: this.languageService.LNG("Label.Delete"),
      messageHtml: this.languageService.LNG(
        "Label.Do.You.Want.To.Delete.The.Selected.Rows"
      ),
      buttons: [
        {
          text: this.languageService.LNG("Label.Yes"),
          onClick: (e) => {
            return true;
          },
        },
        {
          text: this.languageService.LNG("Label.No"),
          onClick: (e) => {
            return false;
          },
        },
      ],
    });
    myDialog.show().then((bConfirm) => {
      if (bConfirm) {
        let carrierItemFlowIds: number[] = [];
        let selectedRowsData =
          this.carrierItemFlowGrid.instance.getSelectedRowsData();
        if (selectedRowsData.length > 0) {
          this.onLoading(true);
          for (let i = 0; i < selectedRowsData.length; i++) {
            carrierItemFlowIds.push(selectedRowsData[i].CarrierItemFlowId);
          }

          if (carrierItemFlowIds.length > 0) {
            this.carrierItemFlowService
              .deleteByIds(carrierItemFlowIds)
              .subscribe(
                (result: any) => {
                  // success path
                  this.onLoading(false);
                  this.loadCarrierItemFlows();
                  if (result.IsSuccess) {
                    this.amsNotifierService.success(
                      this.languageService.LNG("Label.DeletedOK")
                    );
                    if (result.Message != null && result.Message.length > 0) {
                      this.amsNotifierService.error(result.Message);
                    }
                    this.refresh.emit(false);
                    this.carrierItemFlowGrid.selectedRowKeys = [];
                  } else {
                    this.amsNotifierService.error(result.ErrorMessage);
                  }
                },
                (error) => {
                  // error path;
                  this.onLoading(false);
                }
              );
          }
        } else {
          this.amsNotifierService.info(
            this.languageService.LNG("Label.Please.Select.Rows.To.Delete")
          );
          this.onLoading(false);
        }
      }
    });
  }

  onEditorPreparing(e) {
    if (e.parentType == "dataRow") {
      e.editorOptions.onFocusIn = function (args) {
        const input = args.element.querySelector(".dx-texteditor-input");
        if (input !== null && input !== undefined) {
          input.select();
        }
      };
    }
  }

  onEditingStart(e) {
    this.editingStart.emit(e);
  }

  onSavingMultiple(e) {
    this.onLoading(true);
    e.cancel = true;

    let items = [];

    e.changes.forEach((row) => {
      let carrierItemFlow = {
        CarrierItemFlowId:
          row.type == "insert" ? -1 : row.key.CarrierItemFlowId,
        EmployeeId: this.selectedTimeRecord.EmployeeId,
        OldArticleId: row.key.ArticleId ? row.key.ArticleId : -1,
        NewArticleId: row.data.ArticleId ? row.data.ArticleId : row.key.ArticleId,
        CarrierId: this.selectedTimeRecord.CarrierId,
        ItemId: row.data.ItemId ? row.data.ItemId : row.key.ItemId,
        ItemFlowTypeId: 2, // change later,
        StatusId: 1,
        Number: row.data.Number ? row.data.Number : row.key.Number,
        Date: this.selectedTimeRecord.Date,
      };

      items.push(carrierItemFlow);
    });

    this.carrierItemFlowService.saveMultipleCarrierItems(items).subscribe(
      (result: any) => {
        // success path
        if (result.IsSuccess) {
          this.onLoading(false);
          this.loadCarrierItemFlows();
          this.amsNotifierService.success(
            this.languageService.LNG("Label.SavedOK")
          );
          if (result.Message != null && result.Message.length > 0) {
            this.amsNotifierService.error(result.Message);
          }
          e.component.cancelEditData();
        } else {
          this.amsNotifierService.error(result.ErrorMessage);
        }
      },
      (error) => {
        // error path;
        console.log(error);
      }
    );
    e.component.refresh(true);
    e.component.cancelEditData();
  }

  async onInitNewRow(e) {
    if (!this.isClone) {
      e.data.CarrierItemFlowId = -1;
      e.data.CarrierId = this.selectedTimeRecord.CarrierId;
    } else {
      //clone project and employee
      e.data.CarrierItemFlowId = this.cloneData.CarrierItemFlowId;
      e.data.ItemName = this.cloneData.ItemName;
      e.data.ArticleId = this.cloneData.ArticleId;
      e.data.ItemId = this.cloneData.ItemId;
      e.data.ItemFlowTypeId = this.cloneData.ItemFlowTypeId;
      e.data.Number = this.cloneData.Number;
      e.data.CurrencyCode = this.cloneData.CurrencyCode;
    }

    this.isClone = false;
  }

  setAllowEdit(allow: boolean) {
    this.allowEdit = allow;
  }

  onLoading(loading: boolean) {
    this.loading.emit(loading);
  }
}
